import { ITHit } from "webdav.client";

function initializateLicense() {
    ITHit.WebDAV.Client.LicenseId = '00fb53ba-1437-4556-88e0-a9a281de6c8a';
}
initializateLicense();
